module.exports = __webpack_public_path__ + "static/media/pricingDiscountBannerBg.a31d1dcd.png";